import { create } from 'zustand'
import type { Member } from '@/features/members/types/member'

type State = {
  members: Array<Member>
  add: (member: Member) => void
  update: (member: Member) => void
  remove: (_id: string) => void
  setMembers: (members: Array<Member>) => void
}

const initial: Array<Member> = []

export const useMembersStore = create<State>((set, get) => ({
  members: initial,
  add: (member) => {
    set({ members: [...get().members, member] })
  },
  update: (member) => {
    set({
      members: get().members.map((x) =>
        x._id === member._id ? { ...x, ...member } : x,
      ),
    })
  },
  remove: (id) => set({ members: get().members.filter((x) => x._id !== id) }),
  setMembers: (members) => set({ members }),
}))
